var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHorizontalScrollLeftIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3.73333,
    transform: "matrix(-1 0 0 1 36 0)",
    fill: "#F1F1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4672 25.4617C22.5419 25.5365 22.6012 25.6252 22.6417 25.7229C22.6822 25.8206 22.703 25.9253 22.703 26.031C22.703 26.1368 22.6822 26.2415 22.6417 26.3392C22.6012 26.4369 22.5419 26.5256 22.4672 26.6004C22.3924 26.6752 22.3036 26.7345 22.2059 26.775C22.1082 26.8154 22.0035 26.8362 21.8978 26.8362C21.7921 26.8362 21.6874 26.8154 21.5897 26.775C21.492 26.7345 21.4032 26.6752 21.3284 26.6004L13.2809 18.5529C13.2061 18.4782 13.1468 18.3894 13.1063 18.2917C13.0658 18.194 13.0449 18.0893 13.0449 17.9836C13.0449 17.8778 13.0658 17.7731 13.1063 17.6754C13.1468 17.5777 13.2061 17.4889 13.2809 17.4142L21.3284 9.3667C21.4794 9.21569 21.6842 9.13086 21.8978 9.13086C22.1113 9.13086 22.3162 9.21569 22.4672 9.3667C22.6182 9.5177 22.703 9.7225 22.703 9.93606C22.703 10.1496 22.6182 10.3544 22.4672 10.5054L14.988 17.9836L22.4672 25.4617Z",
    fill: "#4846E0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHorizontalScrollLeftIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HorizontalScrollLeftIcon.eb1e0c7b.svg";
export { ForwardRef as ReactComponent };